import CAApi from './_caApi';

class CAReceiptFixedAssetAPI extends CAApi {
  constructor() {
    super();
  }
  controllerName = 'CAReceiptFixedAssets';
}

export default new CAReceiptFixedAssetAPI();
